import React, { useState, useEffect }
  from 'react';
import PropTypes from 'prop-types';

const TierAllocationBlock = ({
  tierAllocTitle,
  beneficialOwner,
  details,
  displayTierAllocationValue,
  isEdit,
  onTierAllocationChange,
  isImyLayer,
  disabled
}) => {
  const [detailsState, setDetailsState] = useState(details);

  const handleChange = (e) => {
    const { value } = e.target;
    setDetailsState(prevDetails => ({
      ...prevDetails,
      tierAllocation: value,
    }));
    onTierAllocationChange(value);
  };

  useEffect(() => {
    setDetailsState(details);
  }, [details]);

  return (
    <div className="allocation-group">
      <div className="allocation-title">
        {tierAllocTitle}
      </div>
      {(!isEdit)
      && <div
        className="allocation-value"
        data-testid="label-tier-allocation"
      >
        {displayTierAllocationValue(beneficialOwner)} %
      </div>}
      {(isEdit)
      && <div className="tier-allocation-input">
        <input
          type="number"
          value={ detailsState.tierAllocation }
          onChange={ handleChange }
          data-testid="field-tier-allocation-value"
          disabled={ disabled }
        />
        <span className="percentage-symbol"> %</span>
      </div>}
    </div>
  );
};

TierAllocationBlock.propTypes = {
  tierAllocTitle: PropTypes.string.isRequired,
  beneficialOwner: PropTypes.shape().isRequired,
  details: PropTypes.shape({
    tierAllocation: PropTypes.number
  }).isRequired,
  displayTierAllocationValue: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  onTierAllocationChange: PropTypes.func.isRequired,
  isImyLayer: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default TierAllocationBlock;
